<section>
  <div>
    <h3>Cost Center Type</h3>
      <div class="form-group costCenterType">
          <label>Type</label>
          <select required [(ngModel)]="costCenter.costCenterType" id="costCenterType" (change)="changeType()" [disabled]="isCostCenterTypeDisabled ||hasSelectedConfiguration">
            <option [value]="null"></option>
            <option value="inpatient">Inpatient Nursing</option>
            <option value="ancillary">Nursing, Procedural, and Ancillary</option>
          </select>
      </div>
    <smt-ancillary *ngIf="costCenter.ancillaryConfiguration && isAncillary" [(configuration)]="costCenter.ancillaryConfiguration" [readOnly]="readOnly"></smt-ancillary>
    <smt-inpatient *ngIf="costCenter.inpatientConfiguration && isInpatient" [(configuration)]="costCenter.inpatientConfiguration" [readOnly]="readOnly"></smt-inpatient>
  </div>  
 </section> 
